const UrlImage = "https://laravel-tamandev.000webhostapp.com";
export default UrlImage;
